import styled from "styled-components";

const STYLES = {
    closeButtonPosition: 18,
    dividerHeight: 1,
};

export const CloseButton = styled.div`
    position: absolute;
    top: ${STYLES.closeButtonPosition}px;
    right: ${STYLES.closeButtonPosition}px;
`;

export const DataPointContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    marginBottom: `${theme.spacing.xLarge}`,
}));

export const PointTextContainer = styled.div(({ theme }) => ({
    marginLeft: `${theme.spacing.xSmall}`,
}));

export const DataContainer = styled.div(({ theme }) => ({
    padding: `${theme.spacing.medium}`,
}));

export const TagContainer = styled.div(({ theme }) => ({
    margin: `${theme.spacing.small} 0 ${theme.spacing.xxSmall}`,
}));

export const Divider = styled.div(({ theme }) => ({
    margin: `${theme.spacing.large} 0`,
    height: `${STYLES.dividerHeight}px`,
    backgroundColor: `${theme.colors.light.border_Tertiary}`,
}));

export const CtaContainer = styled.div(({ theme }) => ({
    paddingTop: `${theme.spacing.small}`,
}));
